module.exports = __webpack_public_path__ + "static/img/third1_5_active.5b71edcd.png";